export const projectsData = [
    {
        _id: 1,
        title: "Admin-Dashboard",
        description: "Display backend data on a nice UI Admin Dashboard, customable for every website",
        frontend: ["React", "TypeScript", "Tailwind CSS", "Cloudinary"],
        backend: ["Node.js", "Express", "MongoDB"],
        githubLink: "https://github.com/rbsPREET/admin-dashboard",
        images: ["https://res.cloudinary.com/dvvqj0wwi/image/upload/v1660171068/portfolio/projects/admin-db1_hekt53.png", "https://res.cloudinary.com/dvvqj0wwi/image/upload/v1660171067/portfolio/projects/admin-db2_man1ns.png", "https://res.cloudinary.com/dvvqj0wwi/image/upload/v1660171067/portfolio/projects/admin-db-3_wckvsv.png"]
    },
    {
        _id: 2,
        title: "ShareWithUs",
        description: "Share your own stories anonymously with other people",
        frontend: ["React", "Material UI (MUI)", "Cloudinary"],
        backend: ["Node.js", "Express", "MongoDB"],
        githubLink: "https://github.com/rbsPREET/sharewithus",
        images: ["https://res.cloudinary.com/dvvqj0wwi/image/upload/v1660171581/portfolio/projects/share1_phpclb.png", "https://res.cloudinary.com/dvvqj0wwi/image/upload/v1660171580/portfolio/projects/share3_ufaatv.png", "https://res.cloudinary.com/dvvqj0wwi/image/upload/v1660171580/portfolio/projects/share2_e5fyul.png"]
    },
    {
        _id: 4,
        title: "Links - Instagram",
        description: "Links Bio for Instagram or a Business",
        frontend: ["React", "Tailwind CSS", "Vanta JS"],
        githubLink: "https://github.com/rbsPREET/links",
        websiteLink: "https://rbslinks.netlify.app",
        images: ["https://res.cloudinary.com/dvvqj0wwi/image/upload/v1660170352/portfolio/projects/links_igpi5g.png"]
    },
    {
        _id: 5,
        title: "TickTacToe",
        description: "Tick Tac Toe game on the console",
        backend: ["Java", "CMD"],
        githubLink: "https://github.com/rbsPREET/tic_tac_toe",
        images: ["https://res.cloudinary.com/dvvqj0wwi/image/upload/v1660168112/portfolio/projects/ticktactoe2_vfp7qm.png", "https://res.cloudinary.com/dvvqj0wwi/image/upload/v1660168111/portfolio/projects/ticktactoe1_mwwqk9.png"]
    },
]